<template lang="pug">
  .content(id="content")
    img.background__img(
      src="@/assets/img/background/1361x768-oscuro.jpg"
      srcset="@/assets/img/background/1361x768-oscuro.jpg 1x, @/assets/img/background/2000x1125-oscuro.jpg 2x, @/assets/img/background/4000x2250-oscuro.jpg 3x"
    )
    VideoDialog
    PWADialog(v-if="showAlert")
    .main-container
      .container__center
        h2.main-title.strong CIUDADANOS
        h3.subtitle en el <strong>centro</strong> de las <strong> soluciones</strong><br>
          | de las <strong>inundaciones</strong> de los<br>
          | <strong> Bañados</strong> de Asunción
        v-btn.show-projects(color="#da7127" to :href="hrefify({ name: 'projects' })") VER PROYECTOS
        v-btn.btn-down.v-btn--small(icon @click="scrollTo('#asuParticipa')")
          i.material-icons.ap-scroll-down
    .description-container
      h1.asuParticipa-title(id="asuParticipa") AsuParticipa para AsuCostera
      .description-container__main
        .description-container__text
          p En esta plataforma se presentan proyectos del <strong> Plan Maestro</strong><br>
            | <strong>de la Franja Costera de Asunción</strong> (i.e. infraestructura, espacios <br>
            | públicos, barrios sociales nuevos, consolidación de barrios, <br>
            | urbanización privada), que <strong> son vistos como solución</strong><br>
            | <strong>definitiva a la inundación de las costas</strong> de Asunción.<br><br>
            | Los proyectos son responsabilidad de los entes planificadores <br>y/o ejecutores, <strong> AsuParticipa</strong> sólo promueve el acceso a la <br>
            | información sobre los proyectos.
        img.image-collage(src="@/assets/img/renders-inicio.jpg")
    .links-container
      .links-container__card
        v-card.card-img
          img(src="@/assets/img/asuparticipa.png")
        p.card-text Provee asistencia técnica <br/>para generar mecanismos de<br/>participación ciudadana...
        v-btn.show-more(color="#da7127" to :href="hrefify({ name: 'asuparticipa' })") VER MÁS
      .links-container__card
        v-card.card-img
          img(src="@/assets/img/asucostera.png")
        p.card-text Un proyecto que inició <br/>hace más de 25 años, y hoy<br/>es un plan que integra la...
        v-btn.show-more(color="#da7127" to :href="hrefify({ name: 'asucostera' })") VER MÁS
      .links-container__card
        v-card.card-img
          img(src="@/assets/img/asuviva.png")
        p.card-text El Plan Maestro de la <br/>Ciudad de Asunción busca<br/>una ciudad reconciliada...
        v-btn.show-more(color="#da7127" to :href="hrefify({ name: 'asuviva' })") VER MÁS
    .how-to-participe__container
      h1.how-to-participe__title ¿Cómo participar?
      .how-to-participe-container__description
        p El mecanismo de participación ciudadana
          | permite la interacción de la ciudadanía a
          | través de consultas, sugerencias y reclamos
          | que contribuyan con la responsabilidad pública
          | de las instituciones respecto a los proyectos
          | de las obras de infraestructura del Plan Maestro
          | de la Franja Costera - AsuCostera.
        p A través del mecanismo, los ciudadanos
          | podrán CONSULTAR sobre los proyectos de
          | obras de AsuCostera, ubicación, beneficios,
          | impactos, situación, etc. SUGERIR mejoras y
          | RECLAMAR por ejemplo, el incumplimiento de
          | normas, acuerdos o procedimientos vinculados
          | a las obras de AsuCostera.
    .share-panel-container
      SharePanelWithProjectList.share-panel-footer(:footer="true" :projectInfo="{ name: '', code: '', }" :isParticipaPage="true")
    .footer-container
      .above-footer
        v-btn.btn-top.v-btn--small(icon @click="scrollTo('#content')")
          i.material-icons.ap-scroll-down
    Footer
</template>
<script>
import programas from '@/mixins/programas.js'

export default {
  mixins: [ programas ],
  components: {
    SharePanelWithProjectList: _ => import('@/components/participa/SharePanelWithProjectList'),
    VideoDialog: _ => import('@/components/home/VideoDialog'),
    PWADialog: _ => import('@/components/PWADialog'),
    Footer: _ => import('@/components/Footer')
  },
  data: () => ({
    isInRoot: false
  }),
  computed: {
    showAlert () {
      // Detects if the web is running in chrome
      const isChrome = () => {
        return navigator.userAgent.match('CriOS')
      }
      const isIos = () => {
        const userAgent = window.navigator.userAgent.toLowerCase()
        return /iphone|ipad|ipod/.test(userAgent)
      }
      // Detects if device is in standalone mode
      const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone)
      // Checks if should display install popup notification:
      if (isIos() && (isChrome() !== 'CriOS') && !isInStandaloneMode()) {
        return true
      } else if (isIos() && (isChrome() === 'CriOS') && isInStandaloneMode()) {
        return false
      } else {
        return false
      }
    }
  },
  methods: {
    hrefify (routeObj) {
      return this.$router.resolve(routeObj).href
    },
    scrollTo (elementID) {
      document.querySelector(elementID).scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    }
  },
  props: {
    openOnLoad: {
      type: String,
      default: ''
    }
  }
}
</script>
<style scoped lang="stylus">
  @import '~@/styles/variables'

  body
    background-color: rgb(254, 233, 195)

  .content
    align-items: center
    justify-content: center
    a
      text-decoration: none
      color: white
      &:hover
        color: white

  .main-container
    align-items: center
    display: flex
    flex-direction: column
    height: 100vh
    justify-content: space-around
    width: 100vw
    -ms-flex-direction: column

  .background__img
    height: 100vh
    position: absolute
    width: 100vw

  .container__center
    display: flex
    flex-direction: column
    justify-content: space-around
    margin-top: 6rem
    text-align: center
    z-index: 1000

  .main-title
    color: white
    font-family: Raleway
    font-weight: 700
    font-size: 3.3vw
    margin-bottom: 0
    padding: $f5px 0
    padding-left: 0 !important

  .subtitle
    color: white
    font-family: Raleway
    font-weight: 400
    font-size: 2.1vw
    line-height: initial
    margin: 0 auto
    margin-bottom: 1rem
    padding-left: 0 !important

  .subtitle strong
    font-family: Raleway

  .show-projects
    align-self: center
    border-radius: 3rem
    color: white
    font-family: Raleway
    font-size: 1.5em
    padding: 0
    width: 16rem
    height: 3rem

  .btn-down
    align-self: center
    font-size: 5rem
    margin-top: 4rem
    z-index: 10000

    &:hover
      cursor: pointer

  .ap-scroll-down
    color: white
    font-size: 4rem

    &:hover
      cursor: pointer

  .asuParticipa-title
    color: $color_2
    font-family: Raleway
    font-size: 3.1rem
    margin-top: 3rem

  .description-container
    display: flex
    flex-direction: column
    font-family: Raleway
    height: 100vh
    padding-left: 7rem
    width: 100%

  .description-container p, p strong
    font-family: Raleway

  .description-container__main
    align-items: center
    display: flex
    flex-direction: row
    height: inherit
    margin-top: 2rem

  .description-container__text
    background-color: white
    color: $color_0
    font-size: 1.76vw
    height: fit-content
    line-height: initial
    padding-right: 1.5rem
    width: fit-content
    z-index: 1

  .description-container__text p
    line-height: 2.7rem
    padding-top: 5px

  .links-container
    align-items: center
    display: flex
    height: 100vh
    justify-content: space-around
    width: 100vw

  .links-container__card
    text-align: center

  .card-img
    align-items: center
    border-radius: .8rem
    display: flex
    flex-direction: row
    height: 13rem
    justify-content: center
    margin-bottom: 2rem
    padding: 1rem
    width: 20rem

  .card-img img
    height: auto
    padding: 2rem
    width: inherit

  .card-text
    color: $color_0
    font-family: Raleway
    font-size: 1.2rem
    text-align: center

  .show-more
    align-self: center
    border-radius: 3rem
    color: white
    font-family: Raleway
    font-size: 1em
    font-weight: 600
    padding: 0
    width: 10rem

  .how-to-participe__container
    align-items: center;
    color: $color_0
    display: flex
    flex-direction: column
    font-size: 1.15vw
    justify-content: center;
    height: auto
    width: 100vw

    .how-to-participe__title
      align-self: flex-start
      color: $color_2
      font-family: Raleway
      font-size: 3.1vw
      margin-left: 5.5rem
      margin-top: 1rem

    .how-to-participe-container__description
      display: flex
      height: inherit
      justify-content: space-around
      width: 100vw

      p
        font-family: Raleway
        font-size: 1.3vw
        line-height: 2rem
        padding: 0 4rem
        text-align: justify

  .share-panel-container
    display: flex
    justify-content: center

    .share-panel-footer
      z-index: 1000

  .footer-container
    heigth: auto
    .above-footer
      align-items: center
      background-color: $gray
      display: flex
      justify-content: flex-end
      height: 13rem
      margin-top: -6rem
      padding: 0 10rem
      opacity: .5

      .btn-top
        margin-bottom: 3rem
        transform: rotate(180deg)

  .image-collage
    position: absolute;
    right: 0;
    width: 50%;
    z-index: 0;

  @media screen and (min-width: 301px) and (max-width: 350px)
    .isMobile .main-title,
    .isMobile .subtitle
      margin: 0
      padding-left: 0 !important

  @media screen and (min-width: 351px) and (max-width: 400px)
    .isMobile .main-title,
    .isMobile .subtitle
      margin: 0
      padding-left: 0 !important

  @media screen and (min-width: 401px) and (max-width: 500px)
    .isMobile .main-title,
    .isMobile .subtitle
      margin: 0
      padding-left: 0 !important

  @media screen and (max-width: 768px)
    .isMobile .main-title,
    .isMobile .subtitle
      margin: 0
      padding-left: 0 !important

  @media screen and (max-width: 1200px)
    .image-collage
      width: 60%;
    .links-container__card
      width: 28vw;
    .links-container__card .card-img
      height: 18vw;
      width: 100%;
    .links-container__card .card-text
      font-size: 1rem;
  @media (max-width: 980px)
    .image-collage
      width: 75%;
    .above-footer .material-icons.ap-scroll-down
      display: none !important;
  @media screen and (max-width: 900px)
    .description-container
      padding-left: 80px;
    .asuParticipa-title, .how-to-participe__title
      font-size: 1.5rem !important;
    .links-container
      flex-wrap: wrap;
      min-height: 100vh;
      height: auto;
    .links-container__card
      text-align: center;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      width: 100%;
      margin: 20px 0;
    .links-container__card .card-img
      width: 40vw;
      height: 30vw;
    .how-to-participe-container__description
      flex-direction: column;
    .how-to-participe-container__description p
      font-size: 1.2rem !important;
  @media screen and (max-width: 850px)
    .image-collage
      width: 100%;
    .how-to-participe-container__description p
      padding: 0 2rem !important;
    .how-to-participe__container h1
      margin-left: 2rem !important;
    .description-container__text p
      font-size: 1.2rem;
    .description-container__text
      padding: 40px;
    .description-container
      padding: 0 40px;
      min-height: 100vh;
      height: auto;
      position: relative;
    .description-container__main
      display: flex;
      justify-content: center;
      align-items: flex-start;
    .image-collage
      width: auto;
      bottom: 0;
  @media screen and (max-width: 750px)
    .links-container__card .card-img
      width: 50vw;
      height: 35vw;
  @media screen and (max-width: 600px)
    .description-container
      padding: 0 15px;
      min-height: 100vh;
      height: auto;
    .description-container__text
      padding: 0 12px;
    .description-container__text p
      line-height: 2rem;
    .description-container__main
      align-items: flex-start;
  @media all and (orientation: landscape)
    .container__center
      margin-top: 0;
  @media screen and (max-width: 850px) and (max-height: 450px)
    .description-container__text
      margin-bottom: 150px;
    .btn-down
      margin-top: 1rem;
    .container__center
      margin-top: 3rem !important;
    .description-container__text p
      line-height: 2rem;
  @media screen and (max-width: 450px)
    .card-img img
      padding: 1rem;
</style>
